import React from 'react';
import PropTypes from 'prop-types';
import useTrackDiscountUIShown from 'hooks/useTrackDiscountUIShown';

/**
 * Mounts discount UI impression tracking beside a filtered result list.
 *
 * @param {Object} props - Tracker props.
 * @returns {null} This component does not render UI.
 */
const DiscountUITracker = (props) => {
  useTrackDiscountUIShown(props);

  return null;
};

DiscountUITracker.propTypes = {
  trips: PropTypes.array.isRequired,
  roundTrip: PropTypes.bool,
  way: PropTypes.string.isRequired,
  analyticsSearchData: PropTypes.object,
  searchIsPolling: PropTypes.bool,
  searchDate: PropTypes.string,
  departureTrip: PropTypes.object,
  scopeId: PropTypes.string,
};

DiscountUITracker.defaultProps = {
  roundTrip: false,
  analyticsSearchData: null,
  searchIsPolling: false,
  searchDate: null,
  departureTrip: null,
  scopeId: '',
};

export default React.memo(DiscountUITracker);
